import { NotificationMessages } from '../types';

export const notificationDE: NotificationMessages = {
    'app.notification.title': 'Benachrichtigungscenter',
    "app.notification.generate_file": "Wir erstellen Ihre Datei. Sobald sie fertig ist, erhalten Sie eine Benachrichtigung zum Herunterladen.",
    'app.notification.download_program': 'Programmdetails herunterladen',
};